import { useEffect } from "react";
import React from "react";
import { useParams } from "react-router-dom";

const EditSource = () => {
  let params = useParams();
  useEffect(() => {}, [params]);
  return <div>editlencek sayfa {params.id} </div>;
};

export default EditSource;
